<template>
  <div>
    <div v-if="value" class="w-100" :class="contentClass">
      <slot v-bind="{ value, toggle, on, off }"></slot>
    </div>
    <div v-show="showReveal" class="w-100" :class="revealClass">
      <slot name="reveal" v-bind="{ show: showReveal, toggle, on, off }"></slot>
    </div>
  </div>
</template>
<script>
import { useToggle } from "@vueuse/core";
import { computed, defineComponent, watch } from "vue";

export default defineComponent({
  props: {
    initialValue: {
      type: Boolean,
      default: false,
    },
    contentClass: {
      type: [String, Object, Array],
      default: undefined,
    },
    revealClass: {
      type: [String, Object, Array],
      default: undefined,
    },
  },
  emits: ["off", "on"],
  setup(props, { emit }) {
    const [value, toggle] = useToggle(props.initialValue);

    const showReveal = computed(() => !value.value);

    function on() {
      toggle(true);
      emit("on");
    }

    function off() {
      toggle(false);
      emit("off");
    }

    watch(
      () => props.initialValue,
      (initialValue) => toggle(initialValue)
    );

    return {
      showReveal,
      value,
      toggle,
      on,
      off,
    };
  },
});
</script>
